export default {
  title: 'Enter new password',
  changePasswordButton: 'Restore password',
  returnLogin: {
    button: 'Back to login',
  },
  success: {
    label: 'The password has been updated successfully.'
  },
  password: {
    inputLabel: 'Password',
    confirmInputLabel: 'Confirm password'
  },
  badConfirmPassword: 'The password doesn\'t match.',
  invalidToken: {
    title: 'This link has already been used',
    button: 'Go to login.',
    label: 'Problems accessing your account?',
  }
}
